export default "__VITE_ASSET__Dd6bBjN6__"